import React, { FC, useEffect, useState } from 'react';
import styles from './enrichment-whois-information.module.sass';
import { Typography, Table, Tooltip } from 'antd';
import { ColumnTitle } from '../../../../shared-components/ColumnTitle';
import { InfoCircleFilled } from '@ant-design/icons';
import LoadingSkeleton from '../../../../shared-components/LoadingSkeleton';

function EnrichmentWhoisInformation({
  data,
  status,
  fallbackData,
  fallbackStatus,
  whoisAge,
}) {
  const { Title, Text, Paragraph } = Typography;
  const [whoIsData, setWhoIsData] = useState({});
  const [whoIsFallbackData, setWhoIsFallbackData] = useState({});

  useEffect(() => {
    if (status === 'loaded' && data?.response) {
      setWhoIsData(data?.response?.whois_live);
    }
  }, [status]);

  useEffect(() => {
    if (fallbackStatus == 'loaded' && fallbackData?.response) {
      setWhoIsFallbackData(fallbackData?.response?.whois);
    }
  }, [fallbackStatus]);

  function renderEmails(emails) {
    if (typeof emails === 'string') {
      return emails;
    }
    let ret = [];
    for (let i in emails) {
      ret.push(<Text className={styles.block}>{emails?.[i]}</Text>);
    }
    return ret;
  }

  const columns = [
    {
      title: <ColumnTitle columnName="Name" />,
      dataIndex: 'name',
      key: 'name',
      width: 150,
      render: (value, params) => {
        if (params?.tooltip) {
          return (
            <>
              {value + ' '}
              <Tooltip placement="top" title={params?.tooltip}>
                <InfoCircleFilled />
              </Tooltip>
            </>
          );
        } else {
          return value;
        }
      },
    },
    {
      title: <ColumnTitle columnName="Value" />,
      dataIndex: 'value',
      key: 'value',
      className: 'ant-column-white',
    },
  ];

  function returnTableData({ loading }) {
    return [
      {
        key: 1,
        name: 'Created',
        tooltip: (
          <Paragraph className="m-0">
            The date when the domain is registered
          </Paragraph>
        ),
        value: loading ? (
          <LoadingSkeleton />
        ) : whoIsData?.created ? (
          whoIsData?.created
        ) : whoIsFallbackData?.[0]?.created ? (
          whoIsFallbackData?.[0]?.created
        ) : (
          '-'
        ),
      },
      {
        key: 2,
        name: 'Age',
        tooltip: (
          <Paragraph className="m-0">
            Time frame from the moment registrar (registrant) registered domain
            or IP”
          </Paragraph>
        ),
        value: loading ? <LoadingSkeleton /> : whoisAge ? whoisAge : '-',
      },
      {
        key: 3,
        name: 'Country',
        tooltip: (
          <Paragraph className="m-0">
            The country in which the domain is registered
          </Paragraph>
        ),
        value: loading ? (
          <LoadingSkeleton />
        ) : whoIsData?.country ? (
          whoIsData?.country
        ) : whoIsFallbackData?.[0]?.country ? (
          whoIsFallbackData?.[0]?.country
        ) : (
          '-'
        ),
      },
      {
        key: 4,
        name: 'City',
        tooltip: (
          <Paragraph className="m-0">
            The city in which the domain is registered
          </Paragraph>
        ),
        value: loading ? (
          <LoadingSkeleton />
        ) : whoIsData?.city ? (
          whoIsData?.city
        ) : whoIsFallbackData?.[0]?.city ? (
          whoIsFallbackData?.[0]?.city
        ) : (
          '-'
        ),
      },
      {
        key: 5,
        name: 'Address',
        tooltip: (
          <Paragraph className="m-0">The domain registered address</Paragraph>
        ),
        value: loading ? (
          <LoadingSkeleton />
        ) : whoIsData?.address ? (
          whoIsData?.address
        ) : whoIsFallbackData?.[0]?.address ? (
          whoIsFallbackData?.[0]?.address
        ) : (
          '-'
        ),
      },
      {
        key: 6,
        name: 'Email',
        tooltip: (
          <Paragraph className="m-0">The domain registered email</Paragraph>
        ),
        value: loading ? (
          <LoadingSkeleton />
        ) : whoIsData?.emails ? (
          renderEmails(whoIsData?.emails)
        ) : whoIsFallbackData?.[0]?.emails ? (
          renderEmails(whoIsFallbackData?.[0]?.emails)
        ) : (
          '-'
        ),
      },
      {
        key: 7,
        name: 'ZIP Code',
        tooltip: (
          <Paragraph className="m-0">The domain registered ZIP Code</Paragraph>
        ),
        value: loading ? (
          <LoadingSkeleton />
        ) : whoIsData?.zipcode ? (
          whoIsData?.zipcode
        ) : whoIsFallbackData?.[0]?.zipcode ? (
          whoIsFallbackData?.[0]?.zipcode
        ) : (
          '-'
        ),
      },
      {
        key: 8,
        name: 'Registrar',
        tooltip: (
          <Paragraph className="m-0">
            Registrar who registered the domain
          </Paragraph>
        ),
        value: loading ? (
          <LoadingSkeleton />
        ) : whoIsData?.registrar ? (
          whoIsData?.registrar
        ) : whoIsFallbackData?.[0]?.registrar ? (
          whoIsFallbackData?.[0]?.registrar
        ) : (
          '-'
        ),
      },
    ];
  }

  return (
    <div
      id="enrichmentWhoisInformation"
      className={styles.enrichment_whois_information}
    >
      <Title level={4}>Whois Information</Title>
      <Table
        columns={columns}
        dataSource={returnTableData({ loading: status !== 'loaded' })}
        pagination={false}
      />
    </div>
  );
}

export default EnrichmentWhoisInformation;
